(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/bottom-sheet/assets/javascripts/shared/listeners.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/bottom-sheet/assets/javascripts/shared/listeners.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (listeners)
  });
  ; 

  const DIRECTION_UP = 'up';
  const DIRECTION_DOWN = 'down';
  const DIRECTION_BOTH = 'both';
  const DIRECTION_NONE = 'none';
  const STATE_EXPANDED = 'expanded';
  const STATE_HALF_EXPANDED = 'half-expanded';
  const STATE_COLLAPSED = 'collapsed';
  const STATE_CLOSED = 'closed';
  const BEHAVIOR_STANDARD = 'standard';
  const BEHAVIOR_MODAL = 'modal';
  const BEHAVIOR_HYBRID = 'hybrid';
  const constants = {
    DIRECTION_UP,
    DIRECTION_DOWN,
    DIRECTION_BOTH,
    DIRECTION_NONE,
    STATE_EXPANDED,
    STATE_HALF_EXPANDED,
    STATE_COLLAPSED,
    BEHAVIOR_MODAL,
    BEHAVIOR_STANDARD,
    BEHAVIOR_HYBRID
  };
  ; 

  class Listeners {
    constructor(options) {
      this.utils = options.utils;
    }

    handlePointer(e) {
      const settings = this.utils.getSettings();
      const clientY = e.type === 'touchmove' ? e.changedTouches[0].clientY : e.clientY;
      if (settings.allowSwipeResizeFromContent || settings.allowedDirections === DIRECTION_BOTH) {
        if (settings.isPressed && settings.previousY && Math.abs(settings.previousY - clientY) > 0.5) {
          const difference = Math.abs(settings.previousY - clientY);
          settings.gestureDirection = clientY < settings.previousY ? DIRECTION_UP : DIRECTION_DOWN;
          if (settings.gestureDirection === DIRECTION_UP && settings.allowedDirections === DIRECTION_BOTH || settings.gestureDirection === DIRECTION_UP && settings.allowExpand) {
            settings.allowedDirections = DIRECTION_BOTH;
            settings.currentHeight = settings.currentHeight + difference;
          } else if (settings.gestureDirection === DIRECTION_DOWN && settings.allowedDirections === DIRECTION_BOTH || settings.gestureDirection === DIRECTION_DOWN && settings.allowCollaps) {
            settings.allowedDirections = DIRECTION_BOTH;
            settings.currentHeight = settings.currentHeight - difference;
          }
          settings.currentHeight = settings.currentHeight >= settings.maxHeight + 12 ? settings.maxHeight + 12 : settings.currentHeight;
          settings.resizeEl.style.transitionDuration = "0ms";
          settings.resizeEl.style.maxHeight = "".concat(settings.currentHeight, "px");
          if (settings.imgEl) {
            settings.imgEl.style.transitionDuration = "0ms";
          }
          if (settings.imgEl && settings.imgHeight && settings.currentHeight > settings.minHeight) {
            settings.imgHeight = 144 + (settings.currentHeight - settings.minHeight);
            if (settings.imgHeight > 278) {
              settings.imgHeight = 278;
            }
          } else if (settings.imgEl) {
            settings.imgHeight = 144;
          }
          if (settings.imgEl) {
            settings.imgEl.style.height = "".concat(settings.imgHeight, "px");
            settings.root.style.setProperty('--bottom-sheet-header-image-height', "".concat(settings.imgHeight, "px"));
          }
        }
        settings.previousY = clientY;
      }
      this.utils.updateSettings(settings);
    }

    handleMouseTouchUp(e) {
      const settings = this.utils.getSettings();
      if (settings.isPressed) {
        settings.endTime = new Date().getTime();
        const y = e.type === 'touchend' ? e.changedTouches[0].screenY : e.screenY;
        settings.endY = y;
        settings.isPressed = false;
        if (y === settings.startY && settings.allowClickExpansion) {
          settings.gestureDirection = settings.gestureDirection && settings.gestureDirection === DIRECTION_UP ? DIRECTION_DOWN : DIRECTION_UP;
        }
        const speed = Math.abs(settings.endTime - settings.startTime) / Math.abs(settings.endY - settings.startY) / 2;
        if (settings.allowedDirections === DIRECTION_BOTH || settings.allowedDirections.includes(settings.gestureDirection)) {
          this.utils.setState(speed);
        }
      }
      this.utils.resetStates();
      this.utils.updateSettings(settings);
    }

    handleMouseTouchDown(e) {
      var _settings$el$querySel, _settings$swipeContro;
      const settings = this.utils.getSettings();
      if (settings.el.querySelector('.js-bottom-sheet-draggable').contains(e.target)) {
        e.preventDefault();
        settings.allowClickExpansion = true;
        settings.allowedDirections = DIRECTION_BOTH;
      } else if (settings.allowHeaderSwipe && (_settings$el$querySel = settings.el.querySelector('.js-bottom-sheet-header')) !== null && _settings$el$querySel !== void 0 && _settings$el$querySel.contains(e.target)) {
        settings.allowedDirections = DIRECTION_BOTH;
      } else {
        settings.allowClickExpansion = false;
        settings.allowedDirections = settings.allowExpand ? DIRECTION_UP : settings.allowCollaps ? DIRECTION_DOWN : DIRECTION_NONE;
      }
      (_settings$swipeContro = settings.swipeController) === null || _settings$swipeContro === void 0 || _settings$swipeContro.abort();
      settings.swipeController = new AbortController();
      const y = e.type === 'touchstart' ? e.changedTouches[0].screenY : e.screenY;
      settings.isPressed = true;
      settings.startY = y;
      settings.startTime = new Date().getTime();
      if (e.type === 'touchstart') {
        document.querySelector('body').style.height = '100vh';
        document.querySelector('body').style.overflowY = 'hidden';
        document.addEventListener('touchend', e => {
          this.handleMouseTouchUp(e);
        }, {
          signal: settings.touchController.signal
        });
        document.addEventListener('touchmove', e => {
          this.handlePointer(e);
        }, {
          signal: settings.swipeController.signal
        });
      } else {
        document.addEventListener('mouseup', e => {
          this.handleMouseTouchUp(e);
        }, {
          signal: settings.touchController.signal
        });
        document.addEventListener('mousemove', e => {
          this.handlePointer(e);
        }, {
          signal: settings.swipeController.signal
        });
      }
      this.utils.updateSettings(settings);
    }

    init() {
      const settings = this.utils.getSettings();
      settings.touchController = new AbortController();
      if (!settings.isFixed) {
        var _settings$resizeEl$qu, _settings$resizeEl$qu2;
        settings.el.addEventListener('touchstart', e => {
          this.handleMouseTouchDown(e);
        }, {
          signal: settings.touchController.signal,
          passive: false
        });
        settings.el.addEventListener('mousedown', e => {
          this.handleMouseTouchDown(e);
        }, {
          signal: settings.touchController.signal
        });

        if (!settings.isModal) {
          settings.el.querySelector('.js-bottom-sheet-collapse').addEventListener('click', () => {
            settings.gestureDirection = DIRECTION_DOWN;
            settings.ignoreTwoSteps = true;
            this.utils.updateSettings(settings);
            this.utils.setState(0);
          }, {
            signal: settings.touchController.signal
          });
        }

        settings.el.querySelector('.js-bottom-sheet-draggable').addEventListener('keydown', e => {
          if (e && e.keyCode === 32 || e && e.keyCode === 13) {
            this.utils.toggleState();
          }
        }, {
          signal: settings.touchController.signal
        });

        const focusable = settings.el.querySelector('.js-bottom-sheet-children').querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0];
        if (focusable) {
          focusable.addEventListener('focus', () => {
            if (this.utils.getSettings().state === STATE_COLLAPSED) {
              this.utils.toggleState();
            }
          }, {
            signal: settings.touchController.signal
          });
        }

        const obStartCallback = payload => {
          const set = {
            allowExpand: false,
            allowCollaps: false,
            allowSwipeResizeFromContent: false
          };
          set.allowCollaps = payload[0].isIntersecting;
          set.allowSwipeResizeFromContent = set.allowCollaps || set.allowExpand;
          this.utils.updateSettings(set);
        };
        const obStart = new IntersectionObserver(obStartCallback);
        obStart.observe(settings.startWatch);

        const obEndCallback = payload => {
          const set = {
            allowExpand: false,
            allowCollaps: false,
            allowSwipeResizeFromContent: false
          };
          set.allowExpand = payload[0].isIntersecting;
          set.allowSwipeResizeFromContent = set.allowCollaps || set.allowExpand;
          this.utils.updateSettings(set);
        };
        const footerHeight = (_settings$resizeEl$qu = settings.resizeEl.querySelector('.bottom-sheet-footer')) !== null && _settings$resizeEl$qu !== void 0 && _settings$resizeEl$qu.clientHeight ? (_settings$resizeEl$qu2 = settings.resizeEl.querySelector('.bottom-sheet-footer')) === null || _settings$resizeEl$qu2 === void 0 ? void 0 : _settings$resizeEl$qu2.clientHeight : 0;
        const obEnd = new IntersectionObserver(obEndCallback, {
          rootMargin: "-".concat(footerHeight, "px 0px")
        });
        obEnd.observe(settings.endWatch);
        if (settings.imgEl) {
          const el = settings.el.querySelector('.js-title');
          const rootEl = settings.el.querySelector('.bottom-sheet-content');
          const observer = new IntersectionObserver(_ref => {
            let [e] = _ref;
            if (e.isIntersecting || this.utils.getSettings().state === STATE_COLLAPSED) {
              e.target.classList.remove('bottom-sheet-title-is-sticky');
            } else {
              e.target.classList.add('bottom-sheet-title-is-sticky');
            }
          }, {
            root: rootEl,
            threshold: [0.5],
            rootMargin: '-53px 0px'
          } 
          );
          observer.observe(el);
        }
      }
      if (settings.isModal) {
        const closeIcon = settings.el.querySelector('.bottom-sheet-action-icon');
        const firstFocusableElement = settings.el.querySelector('.js-bottom-sheet-header-control').querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0];
        firstFocusableElement.focus();
        closeIcon.addEventListener('click', () => {
          document.querySelector('body').style.overflowY = 'unset';
          settings.state = STATE_CLOSED;
          this.utils.updateSettings(settings);
          settings.hideSheet();
          this.destroy();
        }, {
          signal: settings.touchController.signal
        });
        const focusCatch = settings.el.querySelector('.js-bottom-sheet-watch-end');
        focusCatch.setAttribute('tabindex', '0');
        focusCatch.addEventListener('focus', () => {
          firstFocusableElement.focus();
        }, {
          signal: settings.touchController.signal
        });
      }

      if (settings.bypassTabOrder && !settings.isModal) {
        this.setTabindex(settings.el, '-1');
        const focusCatch = settings.el.querySelector('.js-bottom-sheet-watch-end');
        const focusCatchTrap = document.querySelector(".js-bottom-sheet-focus-catcher-".concat(settings.id));
        let inFocus;
        focusCatch.setAttribute('tabindex', '0');

        focusCatchTrap.addEventListener('focus', () => {
          this.setTabindex(settings.el, '0');
          if (!inFocus) {
            this.setTabindex(settings.el, '0', () => {
              settings.el.focus();
              settings.state = STATE_HALF_EXPANDED;
              this.utils.updateSettings(settings);
              this.utils.toggleState();
              inFocus = true;
            });
          } else {
            inFocus = false;
          }
        }, {
          signal: settings.touchController.signal
        });
        focusCatch.addEventListener('focus', () => {
          if (inFocus) {
            focusCatchTrap.focus();
            const nextFocusableElement = this.findAdjacentFocusableElements().next;
            inFocus = false;
            if (nextFocusableElement) {
              nextFocusableElement.focus();
              this.setTabindex(settings.el, '-1');
              this.utils.toggleState();
            }
          }
        }, {
          signal: settings.touchController.signal
        });
        settings.el.addEventListener('keydown', e => {
          if (e.shiftKey && e.code === 'Tab' && settings.el === document.activeElement) {
            focusCatchTrap.focus();
            const previousFocusableElement = this.findAdjacentFocusableElements().previous;
            inFocus = false;
            if (previousFocusableElement) {
              previousFocusableElement.focus();
              this.setTabindex(settings.el, '-1');
              this.utils.toggleState();
            }
          }
        }, {
          signal: settings.touchController.signal
        });
      }

      const sheetContent = settings.el.querySelector('.js-bottom-sheet-content');
      const checkIfScrollable = () => {
        const isScrollable = sheetContent.scrollHeight > sheetContent.clientHeight;
        if (isScrollable) {
          this.utils.setMeasurements();
        }
      };

      const observer = new MutationObserver(checkIfScrollable);

      observer.observe(sheetContent, {
        childList: true,
        subtree: true
      });

      this.utils.updateSettings(settings);
      this.utils.setState();
    }
    destroy() {
      var _settings$touchContro, _settings$swipeContro2;
      const settings = this.utils.getSettings();
      (_settings$touchContro = settings.touchController) === null || _settings$touchContro === void 0 || _settings$touchContro.abort();
      (_settings$swipeContro2 = settings.swipeController) === null || _settings$swipeContro2 === void 0 || _settings$swipeContro2.abort();
    }

    findAdjacentFocusableElements() {
      const currentElement = document.activeElement;

      const focusableElements = document.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

      const focusableArray = Array.from(focusableElements);

      const currentIndex = focusableArray.indexOf(currentElement);

      const nextIndex = currentIndex + 1;
      const prevIndex = currentIndex - 1;

      const nextFocusableElement = nextIndex < focusableArray.length ? focusableArray[nextIndex] : null;
      const prevFocusableElement = prevIndex >= 0 ? focusableArray[prevIndex] : null;

      return {
        next: nextFocusableElement,
        previous: prevFocusableElement
      };
    }

    setTabindex(el, tabIndex, cb) {
      const focusableElements = el.querySelectorAll('button, [href], input, select, textarea');

      el.setAttribute('tabindex', '-1');
      focusableElements.forEach(element => {
        element.setAttribute('tabindex', tabIndex);
      }, cb && cb());
    }
  }
  const listeners = Listeners;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).BottomSheet = window.svs.ui.BottomSheet || {}).BottomSheetListeners = __webpack_exports__["default"];
})();

 })(window);